import React, { useCallback, useEffect, useMemo } from 'react'

import ApproverListModal from '../../../../components/ApproverListModal'
import {
  BlockLeft,
  BlockRight,
  ContentWrapper,
  ViewDetailContent,
} from './ProposalDetailPageStyle'
import DashboardLayout from '../../../../layouts/DashboardLayout'
import { Helmet } from 'react-helmet/es/Helmet'
import PageTitle from '../../../../components/PageTitle'
import ContentBlockWrapper from '../../../../components/ContentBlockWrapper'
import { inject, observer } from 'mobx-react'
import ProposalDetailVehiclePage from './ProposalDetail/ProposalDetailVehicle'
import ProposalDetailLeavesPage from './ProposalDetail/ProposalDetailLeaves'
import ProposalDetailOtherPage from './ProposalDetail/ProposalDetailOther'
import loadingAnimationStore from '../../../../stores/loadingAnimationStore'
import {
  EmptyText,
  TitleContentBox,
} from '../../../../components/Common/CellText'
import { Dropdown, Menu, message, Modal, Row, Col, Tabs } from 'antd'
import { HeadingButtonWrapper } from '../../../MissionDetailPage/MissionDetailPageStyled'
import { KeyValueItem } from '../../../../components/Common/KeyValueItem'
import {
  CheckOutlined,
  DeleteOutlined,
  EditOutlined,
  FileExcelOutlined,
  FileImageOutlined,
  FilePdfOutlined,
  FileTextOutlined,
  FileWordOutlined,
  FileZipOutlined,
  MoreOutlined,
  PlusCircleOutlined,
  QuestionCircleOutlined,
  StopOutlined,
  FormOutlined,
} from '@ant-design/icons'
import { blue, green, purple9, redPrimary } from '../../../../color'
import {
  ACL_ACTION_TYPE,
  PROPOSAL_STATUS,
  PROPOSAL_TYPE,
  TYPE_STATUS,
  DATE_FORMAT_DEFAULT,
} from '../../../../constants'
import ProposalComment from './ProposalComment'
import { StatusTag } from '../../../../components/Common/StatusTag'
import SpinnerInlineComponent from '../../../../components/SpinnerInlineComponent'
import ProposalDetailAction from './ProposalDetail/ProposalDetailAction'
import { AttachmentList } from './ProposalDetail/ProposalDetailStyled'
import FileItem from '../../../../components/Common/FileItemComponent/FileItem'
import utils from '../../../../utils'
import { DocumentInfoList } from '../../../../layouts/ThongTinChungLayout/ThongTinChungLayoutStyled'
import PopoverWatchTime from '../../../../components/PopoverWatchTime'
import { useState } from 'react'
import ProposalDetailUpdate from './ProposalDetailUpdate'
import ProposalDetailUpdateFollowers from './ProposalDetailUpdateFollowers'
import moment from 'moment'
import { toJS } from 'mobx'

const { confirm } = Modal

const ProposalDetailPage = props => {
  const {
    proposalStore,
    match,
    history,
    notificationStore,
    aclStore,
    commonStore,
    authenticationStore,
    proposalTypeStore,
  } = props
  const { proposalId, typePage } = match.params
  const { otherDetail } = proposalStore
  // Không xóa dòng khai báo aclActionsByUser (dù k dùng)
  const { aclActionsByUser } = aclStore
  const [isVisibleUpdateModal, setIsVisibleUpdateModal] = useState(false)
  const [
    isVisibleUpdateFollowersModalModal,
    setIsVisibleUpdateFollowersModalModal,
  ] = useState(false)
  const { isAccountAdmin } = authenticationStore

  const handleApprovalProposal = async data => {
    loadingAnimationStore.showSpinner(true)
    try {
      await proposalStore.approvalProposalOther(data)
      await proposalStore.getOtherDetail(proposalId)
      await proposalStore.getOtherComment(proposalId)
      if (data.type === PROPOSAL_STATUS.REJECT) {
        return message.success('Hủy thành công!')
      }
      return message.success('Duyệt thành công!')
    } catch (e) {
      console.log(e)
      if (data.type === PROPOSAL_STATUS.REJECT) {
        return message.error('Hủy thất bại!')
      }
      return message.error('Duyệt thất bại!')
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
  }

  const handleDeleteProposal = async () => {
    try {
      loadingAnimationStore.showSpinner(true)
      await proposalStore.deleteProposalItem(proposalId)
      history.push('/proposal')
      message.success('Xóa thành công!')
    } catch (err) {
      console.log(err)
      message.error(err.vi || 'Đã có lỗi xảy ra, vui lòng thử lại!')
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
  }

  const showConfirmApproval = type => {
    confirm({
      title: `Bạn có muốn ${
        type === PROPOSAL_STATUS.APPROVAL ? 'duyệt' : 'hủy'
      } thông tin này không?`,
      icon:
        type === PROPOSAL_STATUS.APPROVAL ? (
          <CheckOutlined style={{ color: blue }} />
        ) : (
          <StopOutlined style={{ color: 'red' }} />
        ),
      okText: 'Đồng ý',
      cancelText: 'Không',
      okType: type === PROPOSAL_STATUS.APPROVAL ? 'primary' : 'danger',
      onOk() {
        handleApprovalProposal({
          proposalCode: proposalId,
          type: type,
        }).then(() => Promise.resolve())
      },
    })
  }

  const showConfirmDelete = () => {
    confirm({
      title: 'Bạn có muốn xóa thông tin này không?',
      icon: <QuestionCircleOutlined style={{ color: 'red' }} />,
      okText: 'Đồng ý',
      cancelText: 'Không',
      okType: 'danger',
      onOk() {
        handleDeleteProposal()
      },
    })
  }

  useEffect(() => {
    return () => {
      notificationStore.clearNotificationType()
      proposalStore.clearOtherCommentList()
    }
  }, [])

  const handleCancelUpdateModal = () => {
    setIsVisibleUpdateModal(false)
    proposalStore.clearFormProposalType()
  }

  const handleOpenUpdateModal = () => {
    setIsVisibleUpdateModal(true)
  }

  const handleCancelUpdateFollowersModal = () => {
    setIsVisibleUpdateFollowersModalModal(false)
    proposalStore.clearFormProposalType()
  }

  const handleOpenUpdateFollowersModal = () => {
    setIsVisibleUpdateFollowersModalModal(true)
  }

  const checkShowHandleDocument = () => {
    return (
      (otherDetail.proposal_status === PROPOSAL_STATUS.PENDING &&
        otherDetail?.has_no_config_approval_levels) ||
      (otherDetail && !otherDetail?.has_no_config_approval_levels)
    )
  }

  const checkAccessControlUpdateAction = () => {
    console.log(
      'checkAccessControlUpdateAction',
      authenticationStore.currentUser?.username
    )
    return (
      authenticationStore.currentUser?.username ===
      otherDetail.create_user?.user_name
    )
  }

  const checkAccessControlUpdateActionV2 = () => {
    return otherDetail?.approval_levels?.some(
      item => item.username === authenticationStore.currentUser?.username
    )
  }

  const checkHasNoArppovedLevel = () => {
    if (otherDetail.has_no_config_approval_levels) return true

    if (otherDetail.approval_levels)
      return otherDetail.approval_levels
        .slice(1)
        .every(level => level.status !== 'APPROVED')
  }

  const menuHandleDocument = (
    <Menu style={{ borderRadius: 8, padding: '4px 8px' }}>
      {otherDetail.proposal_status === PROPOSAL_STATUS.PENDING &&
        otherDetail?.has_no_config_approval_levels && (
          <>
            {aclStore.checkAccessControlAction(
              ACL_ACTION_TYPE.approve__PROPOSAL
            ) && (
              <Menu.Item
                onClick={() => showConfirmApproval(PROPOSAL_STATUS.APPROVAL)}
                style={{ color: blue }}
                icon={<CheckOutlined />}>
                Duyệt phiếu
              </Menu.Item>
            )}
            {aclStore.checkAccessControlAction(
              ACL_ACTION_TYPE.approve__PROPOSAL
            ) && (
              <Menu.Item
                onClick={() => showConfirmApproval(PROPOSAL_STATUS.REJECT)}
                style={{ color: 'red' }}
                icon={<StopOutlined />}>
                Từ chối
              </Menu.Item>
            )}
          </>
        )}

      {otherDetail && !otherDetail?.has_no_config_approval_levels && (
        <>
          {checkAccessControlUpdateAction() && (
            <Menu.Item
              style={{ color: blue }}
              onClick={handleOpenUpdateModal}
              icon={<EditOutlined />}>
              Chỉnh sửa
            </Menu.Item>
          )}
        </>
      )}

      {otherDetail &&
        (isAccountAdmin || checkAccessControlUpdateActionV2()) && (
          <>
            <Menu.Item
              onClick={handleOpenUpdateFollowersModal}
              icon={<FormOutlined />}>
              Chỉnh sửa danh sách người theo dõi
            </Menu.Item>
          </>
        )}

      {otherDetail &&
        (aclStore.checkAccessControlAction(ACL_ACTION_TYPE.delete__PROPOSAL) ||
          isAccountAdmin ||
          checkAccessControlUpdateAction()) && (
          <Menu.Item
            danger
            onClick={showConfirmDelete}
            icon={<DeleteOutlined />}>
            Xóa
          </Menu.Item>
        )}
    </Menu>
  )
  const [proposalTypes, setProposalTypes] = useState([])
  useEffect(() => {
    const fetchData = async () => {
      const response = await proposalTypeStore.getAllProposalTypes()
      setProposalTypes(response.data)
    }
    fetchData()
  }, [])
  const renderTitlePage = useMemo(() => {
    for (const [value] of Object.entries(PROPOSAL_TYPE)) {
      if (otherDetail.proposal_type === value) {
        return PROPOSAL_TYPE[value].label
      }
    }
    const foundItem = proposalTypes.find(
      item => item.id == otherDetail.proposal_type
    )
    if (foundItem) {
      return foundItem.name
    }
  }, [otherDetail, proposalTypes])

  /** Hiển thị danh sách tài liệu đính kèm */
  const renderFileIcon = file_type => {
    let iconFile = <FileTextOutlined />
    if (file_type === 'pdf') {
      iconFile = <FilePdfOutlined style={{ color: redPrimary }} />
      return iconFile
    }
    if (file_type === 'doc' || file_type === 'docx') {
      iconFile = <FileWordOutlined style={{ color: blue }} />
      return iconFile
    }
    if (
      [
        'jpg',
        'bmp',
        'dib',
        'jpe',
        'jfif',
        'gif',
        'tif',
        'tiff',
        'png',
        'heic',
      ].includes(file_type)
    ) {
      iconFile = <FileImageOutlined style={{ color: purple9 }} />
      return iconFile
    }
    if (file_type === 'rar' || file_type === 'zip') {
      iconFile = <FileZipOutlined style={{ color: '#e67e22' }} />
      return iconFile
    }
    if (file_type === 'xlsx') {
      iconFile = <FileExcelOutlined style={{ color: green }} />
      return iconFile
    }
  }

  const renderAttachmentList = useCallback(() => {
    return otherDetail.attachments?.map(item => {
      return (
        <FileItem
          key={item.file_id}
          file_id={item.file_id}
          file_name={item.file_name}
          file_type={utils.getExtensionFile(item.file_name)}
        />
      )
    })
  }, [commonStore.appTheme, renderFileIcon, otherDetail])

  return (
    <DashboardLayout>
      <Helmet>
        <title>Chi tiết hành chính| Hành Chính</title>
      </Helmet>
      <PageTitle
        location={props.location}
        showTitle={true}
        title={otherDetail.title}
        status={StatusTag(TYPE_STATUS.PROPOSAL, otherDetail.proposal_status)}>
        <HeadingButtonWrapper>
          {checkShowHandleDocument() ? (
            <Dropdown overlay={menuHandleDocument} trigger={['click']}>
              <span className={'btn-style'}>
                <MoreOutlined style={{ color: blue }} />
              </span>
            </Dropdown>
          ) : (
            <></>
          )}
        </HeadingButtonWrapper>
      </PageTitle>

      <ViewDetailContent>
        <ContentWrapper>
          <BlockLeft>
            <div style={{ borderRadius: 16, background: '#f7f7f7', padding: 20 }}>
              <h3 style={{ marginBottom: 20, fontSize: 18, fontWeight: 600 }}>
                Thông tin chung
              </h3>
              <Row gutter={[20, 20]}>
                <Col span={24}>
                  <KeyValueItem label="Loại" value={renderTitlePage} />
                </Col>

                <Col span={12}>
                  <KeyValueItem
                    label="Tài liệu đính kèm"
                    value={
                      otherDetail.attachments?.length !== 0 ? (
                        <>
                          <AttachmentList>{renderAttachmentList()}</AttachmentList>
                        </>
                      ) : (
                        <EmptyText>Không có tài liệu đính kèm.</EmptyText>
                      )
                    }
                  />
                </Col>

                <Col span={12}>
                  <KeyValueItem
                    label="Người theo dõi"
                    value={
                      proposalStore.otherDetail.followers &&
                      proposalStore.otherDetail.followers.length > 0 ? (
                        <PopoverWatchTime
                          userList={proposalStore.otherDetail.followers.map(
                            item => {
                              return {
                                full_name: item.name_lowercase,
                                id: item.user_name,
                                assignee_type: 'USER',
                                last_date_read: item.last_date_read,
                              }
                            }
                          )}
                          title={'Danh sách người theo dõi'}
                        />
                      ) : (
                        <EmptyText>Không có người theo dõi.</EmptyText>
                      )
                    }
                  />
                </Col>

                {otherDetail?.proposal_type === 'LEAVE' && (
                  <Col span={12}>
                    <KeyValueItem
                      label="Loại nghỉ phép"
                      value={
                        otherDetail.type_of_leave === null ||
                        otherDetail.type_of_leave === '' ? (
                          <EmptyText>Không có loại nghỉ phép.</EmptyText>
                        ) : (
                          otherDetail.type_of_leave
                        )
                      }
                    />
                  </Col>
                )}

                {otherDetail?.proposal_type === 'LEAVE_ABNORMAL' && (
                  <Col span={12}>
                    <KeyValueItem
                      label="Lý do"
                      value={
                        otherDetail.reason_for_leaving === null ||
                        otherDetail.reason_for_leaving === '' ? (
                          <EmptyText>Không có lý do.</EmptyText>
                        ) : (
                          otherDetail.reason_for_leaving
                        )
                      }
                    />
                  </Col>
                )}

                <Col span={12}>
                  <KeyValueItem
                    label="Ngày bắt đầu"
                    value={
                      otherDetail.from_date == null ||
                      otherDetail.from_date === '' ? (
                        <EmptyText>Không có ngày bắt đầu.</EmptyText>
                      ) : (
                        moment(otherDetail.from_date).format(DATE_FORMAT_DEFAULT)
                      )
                    }
                  />
                </Col>

                <Col span={12}>
                  <KeyValueItem
                    label="Ngày kết thúc"
                    value={
                      otherDetail.to_date == null ||
                      otherDetail.to_date === '' ? (
                        <EmptyText>Không có ngày kết thúc.</EmptyText>
                      ) : (
                        moment(otherDetail.to_date).format(DATE_FORMAT_DEFAULT)
                      )
                    }
                  />
                </Col>

                {(otherDetail?.proposal_type ===
                  PROPOSAL_TYPE.OVERTIME_NORMAL.key ||
                  otherDetail?.proposal_type ===
                    PROPOSAL_TYPE.OVERTIME_DAYOFF.key ||
                  otherDetail?.proposal_type ===
                    PROPOSAL_TYPE.OVERTIME_HOLIDAY.key) && (
                  <>
                    <Col span={12}>
                      <KeyValueItem
                        label="Số giờ làm thêm"
                        value={
                          otherDetail.overtime === null ||
                          otherDetail.overtime === '' ? (
                            <EmptyText>Không có số giờ làm thêm.</EmptyText>
                          ) : (
                            <>{otherDetail.overtime} giờ</>
                          )
                        }
                      />
                    </Col>
                    <Col span={12}>
                      <KeyValueItem
                        label="Số giờ được duyệt"
                        value={
                          otherDetail.approvalOvertime === null ||
                          otherDetail.approvalOvertime === '' ? (
                            <EmptyText>Không có số giờ được duyệt.</EmptyText>
                          ) : (
                            <>{otherDetail.approvalOvertime} giờ</>
                          )
                        }
                      />
                    </Col>
                  </>
                )}

                <Col span={24}>
                  <KeyValueItem
                    label="Nội dung"
                    value={
                      <div
                        style={{
                          border: '1px solid #E3E8EF',
                          borderRadius: '8px',
                          padding: '16px',
                          backgroundColor: 'white',
                          overflow: 'auto',
                          width: '100%',
                        }}>
                        {typePage === 'vehicle' ? (
                          <ProposalDetailVehiclePage proposalId={proposalId} />
                        ) : typePage === 'other' ? (
                          <ProposalDetailOtherPage proposalId={proposalId} />
                        ) : (
                          <ProposalDetailLeavesPage proposalId={proposalId} />
                        )}
                      </div>
                    }
                  />
                </Col>
              </Row>
            </div>
          </BlockLeft>
          <BlockRight>
            {otherDetail && !otherDetail?.has_no_config_approval_levels ? (
              <ProposalDetailAction />
            ) : (
              <></>
            )}

            <div className="custom-create-page-content-wrapper"><Tabs defaultActiveKey="1"><Tabs.TabPane tab="Ý kiến" key="1">
              <ProposalComment proposalId={proposalId} />
              <SpinnerInlineComponent sizeSpin={'small'} />
            </Tabs.TabPane></Tabs></div>
          </BlockRight>
        </ContentWrapper>
      </ViewDetailContent>

      <ApproverListModal />

      <Modal
        title={'Chỉnh sửa hành chính'}
        onCancel={handleCancelUpdateModal}
        width={1000}
        wrapClassName="custom-modal-wrapper"
        footer={null}
        maskClosable={false}
        visible={isVisibleUpdateModal}
        destroyOnClose>
        {isVisibleUpdateModal && (
          <ProposalDetailUpdate
            proposalType={otherDetail.proposal_type}
            onCancel={handleCancelUpdateModal}
            name={renderTitlePage}
            approvalLevelList={otherDetail.approval_levels || []}
          />
        )}
      </Modal>

      <Modal
        title={null}
        onCancel={handleCancelUpdateFollowersModal}
        width={650}
        wrapClassName="custom-modal-wrapper"
        footer={null}
        maskClosable={false}
        visible={isVisibleUpdateFollowersModalModal}
        destroyOnClose>
        {isVisibleUpdateFollowersModalModal && (
          <ProposalDetailUpdateFollowers
            proposalType={otherDetail.proposal_type}
            onCancel={handleCancelUpdateFollowersModal}
            name={renderTitlePage}
            approvalLevelList={otherDetail?.approval_levels?.[0] || []}
          />
        )}
      </Modal>
    </DashboardLayout>
  )
}

ProposalDetailPage.propTypes = {}

export default inject(
  'proposalStore',
  'notificationStore',
  'aclStore',
  'commonStore',
  'authenticationStore',
  'proposalTypeStore'
)(observer(ProposalDetailPage))
